<template>
  <div class="overlay" :class="{overlay_show: show}">
    <div 
      class="sparkles" 
      v-for="number in 32" 
      v-bind:style="[styles(number), scale]" 
      v-on:click="hideEl()" 
      :class="{active: isActive}"
    >
        <svg class="sparkle-1" width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <polygon fill="#6AC6E2" points="10.998167 0 7.25512415 7.09866667 0 10.8826667 7.25512415 14.9013333 10.998167 22 14.9758374 14.9013333 22 10.8826667 14.9758374 7.09866667"></polygon>
        </svg>
        <svg class="sparkle-2" width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <polygon fill="#00437F" points="7.99866689 0 5.27645392 5.16266667 0 7.91466667 5.27645392 10.8373333 7.99866689 16 10.8915181 10.8373333 16 7.91466667 10.8915181 5.16266667"></polygon>
        </svg>
        <svg class="dot-1" width="6" height="6"> 
        <circle cx="3" cy="3" r="3" fill="#0086FF"/>
        </svg>
    </div>

    <div
      class="sparkles" 
      v-for="number in randNum"  
      v-bind:style="styles(number)"
      v-on:click="hideEl()" 
      :class="{active: isActive}"
    >
        <div class="pulseHome"></div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Sparkle',
    data () {
      return { 
        docHeight: false,
        isActive: false,
        show: false
      }
    },
    computed: {
      randNum () {
        return Math.floor(Math.random() * 10) + 4  
      },
      storeDocHeight () {
        return this.$store.state.docHeight
      }
    },
    methods: {
      styles: function (number) {
        const docWidth = document.body.clientWidth
        const rotateAngle = Math.floor(Math.random() * 360) + 0 

        const top = Math.random() * (this.docHeight - number * 3)
        const left = Math.random() * (docWidth - number * 3 + 10)

        return {
          top: top + 'px',
          left: left + 'px',
          transform: 'rotate(' + rotateAngle + 'deg)',
        }
      },
      scale: function (number) {
        const scale = Math.floor(Math.random() * 1.2) + 0.8  

        return {
          transform: 'scale( ' + scale + ')',
        }
      },
      hideEl: function () {
        this.isActive = !this.isActive
      }
    },
    watch: {
      storeDocHeight: function () {
        this.docHeight = document.body.clientHeight
        this.show = true
      }
    }
  }
</script>
  
<style lang="less">
  @import "../../styles/global.less";
  .overlay {
    opacity: 0;
    transition: opacity 1s 1s;
    &_show {
      opacity: 1;
    }
  }

  svg {
    transform-origin: 50% 50% 0px;
  }

  .sparkles, .pointer, .pulseHome {
    position: absolute;
    z-index: 10000;

    // pointer-events: none;
    user-select: none;
    cursor: pointer;

    transform-origin: -50% -50%;
  }

  .sparkle-1 {
    animation: twinkle 2s ease infinite;
    transition-timing-function: cubic-bezier(.17,.67,.83,.67);
  }


  .sparkle-2 {
    animation: twinkle 2.6s ease infinite;
    transition-timing-function: cubic-bezier(.17,.67,.83,.67);
  }

  .dot-1 {
    position: absolute;
    animation: twinkle2 1.5s ease infinite;
    transition-timing-function: cubic-bezier(.17,.67,.83,.67);
    left: 24px;
  }

  .pulseHome {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #0086FF;
    box-shadow: 0 0 0 rgba(106,198,226, .6);
    animation: pulseHomeHome 2s infinite;
  }

  .pointer {
    top: 38%;
    width: 0; 
    height: 0; 
    border-left: 14px solid transparent;
    border-right: 14px solid transparent;  
    border-bottom: 18px solid #0086FF;
    border-radius: 2px;
    animation: point 2s ease-out infinite;
  }

  @keyframes twinkle {
    0% { opacity: 1; transform: scale(1) }
    50% { opacity: .1; transform: scale(.5) }
    100% { opacity: 1; transform: scale(1) }
  } 


  @keyframes twinkle2 {
    0% { opacity: 1; }
    50% { opacity: .1; transform: scale(.8) }
    100% { opacity: 1; }
  }

  @keyframes point {
    0% { opacity: 0; top: 45%; }
    70% { opacity: 1; }
    100% { opacity: 0; }
  }

  @keyframes pulseHomeHome {
    0% { box-shadow: 0 0 0 2px rgba(106,198,226, 0.6); }
    70% { box-shadow: 0 0 0 20px rgba(106,198,226, 0); }
    100% { box-shadow: 0 0 0 0px rgba(106,198,226, .0); }
  }

</style>


// WEBPACK FOOTER //
// src/components/library/sparkle.vue